import { forwardRef, HTMLAttributes, ReactNode } from "react";
import { cn } from "@/utils/cn";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  children: ReactNode;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ title, children, className = "", ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "card bg-surface-card border-surface-border text-theme-text-heading",
          className,
        )}
        {...props}
      >
        {title && <h3 className="mb-8 text-xl font-medium text-theme-text-heading">{title}</h3>}
        {children}
      </div>
    );
  },
);

Card.displayName = "Card";
